<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import Button from 'dashboard/components-next/button/Button.vue';
import ButtonGroup from 'dashboard/components-next/buttonGroup/ButtonGroup.vue';
import { useUISettings } from 'dashboard/composables/useUISettings';
import { useMapGetter } from 'dashboard/composables/store';
import { useNoteComposerState } from 'dashboard/composables/useNoteComposerState';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';
const route = useRoute();

const { uiSettings, updateUISettings } = useUISettings();
const { isRecordingNoteAudio } = useNoteComposerState();

const isConversationRoute = computed(() => {
  const CONVERSATION_ROUTES = [
    'inbox_conversation',
    'conversation_through_inbox',
    'conversations_through_label',
    'team_conversations_through_label',
    'conversations_through_folders',
    'conversation_through_mentions',
    'conversation_through_unattended',
    'conversation_through_participating',
    'inbox_view_conversation',
  ];
  return CONVERSATION_ROUTES.includes(route.name);
});

// As paginas de detalhe de Contato/Empresa/Negociacao tem um composer
// fixo no rodape (caixa de nota do Historico) que o launcher cobriria
// na posicao padrao - sobe um pouco em vez de sumir.
const DETAIL_ROUTES_WITH_NOTE_COMPOSER = [
  'contacts_edit',
  'companies_dashboard_show',
  'deals_edit',
];
const isDetailRouteWithNoteComposer = computed(() =>
  DETAIL_ROUTES_WITH_NOTE_COMPOSER.includes(route.name)
);

// Gravando audio na nota, o botao de parar fica na mesma barra do
// composer - sobe mais ainda pra nao cobrir ele.
const positionClass = computed(() => {
  if (isRecordingNoteAudio.value) return 'bottom-40';
  return isDetailRouteWithNoteComposer.value ? 'bottom-24' : 'bottom-4';
});

const currentAccountId = useMapGetter('getCurrentAccountId');
const isFeatureEnabledonAccount = useMapGetter(
  'accounts/isFeatureEnabledonAccount'
);

const showCopilotLauncher = computed(() => {
  const isCaptainEnabled = isFeatureEnabledonAccount.value(
    currentAccountId.value,
    FEATURE_FLAGS.CAPTAIN
  );
  return (
    isCaptainEnabled &&
    !uiSettings.value.is_copilot_panel_open &&
    !isConversationRoute.value
  );
});
const toggleSidebar = () => {
  updateUISettings({
    is_copilot_panel_open: !uiSettings.value.is_copilot_panel_open,
    is_contact_sidebar_open: false,
  });
};
</script>

<template>
  <div
    v-if="showCopilotLauncher"
    class="fixed ltr:right-4 rtl:left-4 z-50"
    :class="positionClass"
  >
    <ButtonGroup
      class="rounded-full bg-n-alpha-2 backdrop-blur-lg p-1 shadow hover:shadow-md"
    >
      <Button
        icon="i-woot-captain"
        no-animation
        class="!rounded-full !bg-n-solid-3 dark:!bg-n-alpha-2 !text-n-slate-12 text-xl transition-all duration-200 ease-out hover:brightness-110"
        lg
        @click="toggleSidebar"
      />
    </ButtonGroup>
  </div>
  <template v-else />
</template>
